import { render, staticRenderFns } from "./bulma_googleMyBusiness.vue?vue&type=template&id=42d5a228&scoped=true"
import script from "./bulma_googleMyBusiness.vue?vue&type=script&lang=js"
export * from "./bulma_googleMyBusiness.vue?vue&type=script&lang=js"
import style0 from "./bulma_googleMyBusiness.vue?vue&type=style&index=0&id=42d5a228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d5a228",
  null
  
)

export default component.exports